import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3ba9d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-identicon shadow" }, null, -1 /* HOISTED */))

import makeBlockie from 'ethereum-blockies-base64'
import { computed } from 'vue'

import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppIdenticon',
  setup(__props) {

const appStore = useAppStore()
const appIdenticon = computed(() => {
  const appId = appStore.state.appId
  return appId ? makeBlockie(appId) : ''
})

return (_ctx: any,_cache: any) => {
  return (appIdenticon.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "app-identicon image",
          style: _normalizeStyle({
        backgroundImage: `url(${appIdenticon.value})`,
      })
        }, null, 4 /* STYLE */),
        _hoisted_2
      ]))
    : _createCommentVNode("v-if", true)
}
}

})